<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">اسم الفرع</h5>

                       <span> يرجى ملئ جميع الخانات </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "branchForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> اسم الفرع</label>
                                <input class="form-control" id="validation01" type="text" formControlName="title"
                                [tooltip]="fc.title.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.title.valid && (fc.title.touched)"
                                [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                                
                                     required
                                     placeholder="الأسم"
                                    containerClass="" />
                            </div>
                            <!-- [isDisabled]="!((fc.titleAr.errors?.required && fc.titleAr.touched) || validated)" -->
                            <!-- titleAr  -->
                            <div class="col-6 mb-3">
                                <label for="validation02"><span class="validation-required">*</span> الهاتف</label>
                                <input class="form-control" id="validation02" type="text" formControlName="phone"
                                [tooltip]="fc.phone.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.phone.valid && (fc.phone.touched)"
                                [class.is-invalid]="fc.phone.invalid && (fc.phone.touched)"
                               onlyNumbers
                                     placeholder="رقم الهاتف"
                                    containerClass="" 
                               
                                    />
                            </div>
                            <!-- order       -->
                            <div class="col-6 mb-3">
                                <label for="validation03"><span class="validation-required">*</span> العنوان</label>
                                <input class="form-control" id="validation03" type="text" formControlName="address"
                                [tooltip]="fc.address.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.address.valid && (fc.address.touched)"
                                [class.is-invalid]="fc.address.invalid && (fc.address.touched)"
                                     required
                                     
                                     placeholder="العنوان"
                                    containerClass="" 
                                    />
                            </div>
                            <div class="col-6 mb-3">
                                <label for="validation03"><span class="validation-required">*</span> مدير الفرع</label>
                                <input class="form-control" id="validation03" type="text" formControlName="BranchManager"
                                [tooltip]="fc.BranchManager.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.BranchManager.valid && (fc.BranchManager.touched)"
                                [class.is-invalid]="fc.BranchManager.invalid && (fc.BranchManager.touched)"
                                     required
                                     
                                     placeholder="مدير الفرع"
                                    containerClass="" 
                                    />
                            </div>
                            <div class="col-6 mb-3">
                                <label for="validationCustom05"><span class="validation-required">*</span> المحافظة </label>
                                                             <ng-select #Governorate  [selectOnTab]="true" formControlName="GovernorateId"
                                                                 class="form-control p-0" placeholder="اختر المحافظة" (change)="SelectedGovernorate($event)"
                                                                 containerClass="" 
                                                                 id="validationCustom05">
                                                                 <ng-option *ngFor="let item of Governorates" [value]="item.id">{{item.title}}</ng-option>
                                                             </ng-select>
                                                          
                                                         </div>
                             <div class="col-6 mb-3">
   <label for="validationCustom05"><span class="validation-required">*</span> المدينة </label>
                                <ng-select #Governorate  [selectOnTab]="true" formControlName="cityId"
                                    class="form-control p-0" placeholder="اختر المدينة"
                                    containerClass="" 
                                    id="validationCustom05">
                                    <ng-option *ngFor="let item of city" [value]="item.id">{{item.title}}</ng-option>
                                </ng-select>
                             
                            </div>

                            
                            <div class="col-6 mb-3">
                                <label for="validation03"><span class="validation-required">*</span> الموقع على الخريطة</label>
                                <input class="form-control" id="validation03" type="text" formControlName="MapLink"
                                [tooltip]="fc.MapLink.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.MapLink.valid && (fc.MapLink.touched)"
                                [class.is-invalid]="fc.MapLink.invalid && (fc.MapLink.touched)"
                                     placeholder="عنوان الفرع"
                                    />
                            </div>

          <div class="col-6 my-3 pr-5" >
            <div class="d-flex justify-content-center">
                <img  src="{{ imageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />

              </div>
             
                <div class="d-flex justify-content-center">
               <input type="file" formControlName="branchImage" accept="image/*" #file id="getLogo"
                style="display: none" (change)="getLogoUrl($event)" />
            <button type="button" onclick="document.getElementById('getLogo').click()"
                class="btn   d-block"  style="width: 60%;">
                ارفاق صورة
            </button>    
                  </div>
                
              
                          
                        </div>
                      

                           
                        </div>

                        <br>
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn  pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn  pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>



